import React from 'react';
import StatsCard from './StatsCard'; // Assuming CreditRefunded component is in the same directory
// import { extractTokenRefunded } from '../../../utils/refund';
import PremiumLeadersCard from './PremiumLeadersCard';

const DashboardTopCards = ({ stats, startDate, endDate }) => {
  

 
   const cardData = [
        {
            cardImg: '/assets/incentive-purchased.svg',
            total: stats?.totalCreditRefunded,
            modalTitle: 'Total Credits Refunded',
            columnTitle: 'No. of Credits Issued',
            isUser: false,
        },
        {
            cardImg: '/assets/dashboard/noofagents.svg',
            total: stats?.refunduser, // toatal will be totalRefunduser
            totalAmount : stats?.totalRefunduser[0]?.totalUsersRefunded,
            modalTitle: 'Users Getting Credits',
            columnTitle: 'No. of Users',
            isUser: true,
        },
        {
            cardImg: '/assets/incentive-purchased.svg',
            total: stats?.totalTokenRefunded,
            modalTitle: 'Total Tokens Refunded',
            columnTitle: 'No. of Tokens Refunded',
            isUser: true,
        },
        {
            cardImg: '/assets/dashboard/purchasedamount.svg',
            total: stats?.totalCreditConsumed,
            modalTitle: 'Credits Consumed',
            columnTitle: 'No. of Credits Consumed',
            isUser: false,
        },
        {
            cardImg: '/assets/dashboard/noofagents.svg',
            total: stats?.consumeduser, // toatal will be totalConsumeduser
            totalAmount: stats?.totalConsumeduser[0]?.totalUsersRefunded,
            modalTitle: 'Users Consuming Credits',
            columnTitle: 'No. of Credits Consumed',
            isUser: true,
        },
        
    ];

    return (
        <>
            {cardData.map((card, index) => (
                <StatsCard
                    key={index}
                    cardImg={card.cardImg}
                    totalCreditRefunded={card.total}
                    modalTitle={card.modalTitle}
                    columnTitle={card.columnTitle}
                    totalAmount={card.totalAmount}
                    user={card.isUser}

                />
            ))}
            <PremiumLeadersCard startDate={startDate} endDate={endDate} />
        </>
    );
};

export default DashboardTopCards;
// import React, { useEffect } from 'react';
// import StatsCard from './StatsCard'; // Assuming CreditRefunded component is in the same directory
// import { extractTokenRefunded } from '../../../utils/refund';
// import axios from 'axios';
// import { Api_Url } from '../../../utils/ApiUrl';

// const DashboardTopCards = ({ stats, startDate , endDate  }) => {
// const getStatsData = () => {
//     var config = {
//       method: "get",
//         url: `${Api_Url}/users/platform-stats?privateSale=NFA`,
//       headers: {
//         Authorization: "Bearer " + localStorage.getItem("accessToken"),
//       },
//     };

//     let dynamicQuery = config.url;

//     if (startDate && startDate != null) {
//       dynamicQuery += `&startDate=${startDate}&endDate=${endDate}`;
//     }
//     config.url = dynamicQuery;

//     axios(config)
//       .then(function (response) {
//       })
//       .catch(function (error) {
//         if (error?.response?.status == 401) {
//           // localStorage.removeItem("accessToken");
//           // history.push("/");
//         }
//       });
//     }
//     useEffect(() => {
//         getStatsData()
//     }, [])
    
//     const cardData = [
//         {
//             cardImg: '/assets/incentive-purchased.svg',
//             total: stats?.totalCreditRefunded,
//             modalTitle: 'Total Credits Refunded',
//             columnTitle: 'No. of Credits Issued',
//             isUser: false,
//         },
//         {
//             cardImg: '/assets/dashboard/noofagents.svg',
//             total: stats?.consumeduser,
//             modalTitle: 'Users Getting Credits',
//             columnTitle: 'No. of Users',
//             isUser: true,
//         },
//         {
//             cardImg: '/assets/incentive-purchased.svg',
//             total: extractTokenRefunded(stats?.totalCreditRefunded),
//             modalTitle: 'Total Tokens Refunded',
//             columnTitle: 'No. of Tokens Refunded',
//             isUser: false,
//         },
//         {
//             cardImg: '/assets/dashboard/purchasedamount.svg',
//             total: stats?.totalCreditConsumed,
//             modalTitle: 'Credits Consumed',
//             columnTitle: 'No. of Credits Consumed',
//             isUser: false,
//         },
//         {
//             cardImg: '/assets/dashboard/noofagents.svg',
//             total: stats?.refunduser,
//             modalTitle: 'Users Consuming Credits',
//             columnTitle: 'No. of Credits Consumed',
//             isUser: true,
//         },
        
//     ];

//     return (
//         <>
//             {cardData.map((card, index) => (
//                 <StatsCard
//                     key={index}
//                     cardImg={card.cardImg}
//                     totalCreditRefunded={card.total}
//                     modalTitle={card.modalTitle}
//                     columnTitle={card.columnTitle}
//                     user={card.isUser}
//                 />
//             ))}
//             <div className="single-card">
//                 <div className="twice-set-items">
//                     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19 3H5L2 9L12 21L22 9L19 3ZM9.62 8L11.12 5H12.88L14.38 8H9.62ZM11 10V16.68L5.44 10H11ZM13 10H18.56L13 16.68V10ZM19.26 8H16.61L15.11 5H17.76L19.26 8ZM6.24 5H8.89L7.39 8H4.74L6.24 5Z" fill="#E89735"></path></svg>
//                     <div className="inner-text">
//                         <p>{'Premium Leaders'}</p>
//                         <h6>
//                             {12}
//                             {/* <span className="green-text">+0.8%</span> */}
//                         </h6>
//                     </div>
//                 </div>

//             </div>
//         </>
//     );
// };

// export default DashboardTopCards;